import { helpers } from "vuelidate/lib/validators";

const fileType = param =>
  helpers.withParams({ type: "fileType", value: param }, value => {
    if (!value || !value.name) {
      return true;
    }
    let extension = value.name.match(/\.[^\.]*$/)[0];
    return param
      .map(item => `.${item.toLowerCase()}`)
      .includes(extension.toLowerCase());
  });

export default fileType;
